import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import UniversalConfirmAction from '../../universal-confirm-action';

const ResponsiveContainer = ({
  title,
  dropdowns,
  labelClass,
  buttonClass,
  button,
  disableSubmit,
}: {
  title: string;
  dropdowns?: JSX.Element;
  button: {
    id: string;
    clickCallBack: () => Promise<void>;
    doubleCheck?: boolean;
  };
  labelClass?: string;
  buttonClass?: string;
  disableSubmit?: boolean | false;
}) => {
  const { id, clickCallBack, doubleCheck } = button;
  return (
    <>
      <Grid item xs={12} lg={6}>
        <Box
          pr={3}
          display="flex"
          flex-direction="row"
          alignItems="flex-end"
          justifyContent="space-between"
        >
          <Box pb={2} minWidth={200} className={labelClass}>
            <Typography variant="h6">{title}</Typography>
          </Box>
          {dropdowns && (
            <>
              <Box pb={2} display="flex" overflow="auto" width="100%" px={1}>
                {dropdowns}
              </Box>
              <Box flexGrow="1" />
            </>
          )}
          <Box
            display="flex"
            minWidth={156}
            flexGrow={1}
            justifyContent="flex-end"
            className={buttonClass}
          >
            <UniversalConfirmAction
              id={id}
              clickCallBack={clickCallBack}
              doubleCheck={doubleCheck}
              disabled={disableSubmit}
            />
          </Box>
          <Box pr={0.5} display={{ xs: 'none', lg: 'block' }} />
        </Box>
      </Grid>
    </>
  );
};

export default ResponsiveContainer;
